import { getAnalytics } from "firebase/analytics"
import { FirebaseOptions, initializeApp } from "firebase/app"
import { getAuth } from "firebase/auth"

import { CONFIGURATION } from "@env/variables"

const firebaseConfig: FirebaseOptions = {
    apiKey: CONFIGURATION.firebase.apiKey,
    authDomain: CONFIGURATION.firebase.authDomain,
    projectId: CONFIGURATION.firebase.projectId,
    appId: CONFIGURATION.firebase.appId
}

const firebaseApp = initializeApp(firebaseConfig)
const firebaseAuth = getAuth(firebaseApp)
const analytics = getAnalytics(firebaseApp)

async function getFirebaseAuthToken(refresh?: boolean) {
    const user = firebaseAuth.currentUser
    if (user) {
        return user.getIdToken(refresh).then(token => {
            return token
        })
            .catch((err) => {
                console.error("Failed to get access token", err)
                return null
            })
    } else {
        return Promise.resolve(null)
    }
}

function signOut() {
    return firebaseAuth.signOut()
}

export { analytics, firebaseApp, firebaseAuth, firebaseConfig, getFirebaseAuthToken, signOut }
